module.exports = __webpack_public_path__ + "static/egyptian-pillowcase-navy-1-e4bdf409ad9f31d982dfbfb6c6f5e594.png";